import { classNames } from '@ember-decorators/component';
import Super from 'ember-simplepractice/components/shared/full-flyout/header';
import styles from './header.module.scss';

@classNames(styles.component)
export default class SharedFullFlyoutHeader extends Super {}
